import React, { useEffect, useState } from "react";
import { Button, CloseButton, Modal, Form, InputGroup, ListGroup } from "react-bootstrap";
import { MedicineBoxOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useClinicStore } from "modules/clinic-management/store";
import { useCustomer } from "./store";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

function ClinicAssignment({ name }) {
  const { nearestClnicDetails, nearestClnic, getAssingClinic } = useClinicStore();
  const { customerData } = useCustomer();
  const [modalShow, setModalShow] = useState(false);
  const [locality, setLocality] = useState(""); // State for locality
  const [pincode, setPincode] = useState(""); // State for pin code
  const [searchedClinics, setSearchedClinics] = useState([]); // State for searched clinics
  const { id } = useParams()
  const handleSearch = () => {
    if (locality && pincode) {
      nearestClnicDetails(locality, pincode);
    }
  };

  useEffect(() => {
    setSearchedClinics(nearestClnic);
  }, [nearestClnic]);

  const handleAssignClinic = (clinicId, adminid) => {
    const payload = {
      caseId: id,
      clinicId: clinicId,
      clinicAdminId: adminid
    }
    getAssingClinic(payload, toast)
  };

  return (
    <>
      <Tooltip title={name}>
        <div onClick={() => setModalShow(true)}>
          <span className="mt-n1 bg-primary text-white p-2 rounded-circle d-flex justify-content-center align-items-center shadow">
            <MedicineBoxOutlined />
          </span>
        </div>
      </Tooltip>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="m"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Assign Clinic
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setModalShow(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3">
            <Form.Control
              type="text"
              placeholder="Enter Locality"
              value={locality}
              onChange={(e) => setLocality(e.target.value)}
            />
            <Form.Control
              type="text"
              placeholder="Enter Pin Code"
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
            />
            <Button variant="outline-secondary" onClick={handleSearch}>
              Search
            </Button>
          </InputGroup>
          {searchedClinics.length > 0 && (
            <ListGroup>
              {searchedClinics.map((clinic) => (
                <ListGroup.Item key={clinic._id} className="d-flex justify-content-between align-items-center">
                  <span>{clinic.clinic_name}</span>
                  <Button variant="primary" onClick={() => handleAssignClinic(clinic._id, clinic.user_clinic_id)}>
                    Assign
                  </Button>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ClinicAssignment;
